import { render } from "./AvailableGiftCards.vue?vue&type=template&id=38ce3c62"
import script from "./AvailableGiftCards.vue?vue&type=script&lang=js"
export * from "./AvailableGiftCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__